export default "/images/no.svg?8fb638b600557c49ea49813ce50678ca";